/* eslint-disable no-unused-vars */
import { PopupStatus } from '../../scripts/js/forgeService'
import { getMarkupsComponent } from '../../scripts/js/forgeviewer'

export const MARKUPS = {
    state: {
        //Markups
        markupsPopupStatus: PopupStatus.UNDEFINED,
        markupActiveTool: null,
        activeAttachment: null,
        activeAttachmentPage: null,
        activeAttachmentPagesCount: 0,
        activeMarkupsStyle: null,
        markupActiveStamp: null,
        pdfViewerPreviewingLink: null,
        previewingLinkElement: null,
        markupSymbols: [],
        tagIdToHighlight: null,

        //TestBlind
        testBlindMarkups:[],
        testBlindData: null,
        testBlindsToBeAdded: [],
        testBlindsToBeDeleted: [],
        nextTestBlindSequence: {},
        
        // Comments 
        selectedComment: null,
        isCommentsPanelActive: false,

        // Stamps
        stampsUploadFolder: null,
        stampsUploadActive: false
    },

    mutations: {
        setMarkupsPopupStatus(state, status) {
            state.markupsPopupStatus = status;
        },
        setMarkupActiveTool(state, toolId) {
            state.markupActiveTool = toolId;
        },
        setActiveAttachment(state, attachment) {
            state.activeAttachment = attachment;
        },
        setActiveAttachmentPage(state, pageNumber) {
            state.activeAttachmentPage = pageNumber;
        },
        setActiveAttachmentPagesCount(state, count) {
            state.activeAttachmentPagesCount = count;
        },
        setMarkupSymbols(state, symbols) {
            state.markupSymbols = symbols;
        },
        setActiveMarkupsStyle(state, style) {
            if(style != null) {
                state.activeMarkupsStyle = style;
            }
        },
        setMarkupActiveStamp(state, id) {
            state.markupActiveStamp = id;
        },
        setPdfViewerPreviewingLink(state, previewingLink) {
            state.pdfViewerPreviewingLink = previewingLink;
        },
        setPreviewingLinkElement(state, element) {
            state.previewingLinkElement = element;
        },
        setTestBlindData(state, testBlindData) {
            state.testBlindData = testBlindData;
        },
        setNextTestBlindSequence(state, sequence) {
            state.nextTestBlindSequence = sequence;
        },
        setTestBlindMarkups(state, sequence) {
            state.testBlindMarkups = sequence;
        },
        SET_SELECTED_COMMENT(state, comment) {
            state.selectedComment = comment;
        },
        SET_IS_COMMENTS_PANEL_ACTIVE(state, value) {
            state.isCommentsPanelActive = value;
        },
        setTagIdToHighlight(state, value) {
            state.tagIdToHighlight = value;
        },
        setStampsUploadFolder(state, folder) {
            state.stampsUploadFolder = folder;
        },
        setStampsUploadActive(state, value) {
            state.stampsUploadActive = value;
        },
    },

    actions: {
        
    },

    getters: {
        getMarkupsPopupStatus(state) {
            return state.markupsPopupStatus;
        },
        getMarkupActiveTool(state) {
            return state.markupActiveTool;
        },
        getActiveAttachment(state) {
            return state.activeAttachment;
        },
        getActiveAttachmentPage(state) {
            return state.activeAttachmentPage;
        },
        getActiveAttachmentPagesCount(state) {
            return state.activeAttachmentPagesCount;
        },
        getMarkupSymbols(state) {
            return state.markupSymbols;
        },
        getActiveMarkupsStyle(state) {
            var style = state.activeMarkupsStyle;
            if(style != null) {
                return style;
            }
            var markupsExtension = getMarkupsComponent().autodeskMarkupsExtension;
            if(markupsExtension == null) {
                return null
            }
            style = markupsExtension.getDefaultStyle();
            state.activeMarkupsStyle = style;
            return style;
        },
        getMarkupActiveStamp(state) {
            if(state.markupActiveTool != "stamp") {
                state.markupActiveStamp = null;
            }
            return state.markupActiveStamp;
        },
        getPdfViewerPreviewingLink(state) {
            return state.pdfViewerPreviewingLink
        },
        getPreviewingLinkElement(state) {
            return state.previewingLinkElement
        },
        getTestBlindData(state) {
            return state.testBlindData;
        },
        getNextTestBlindSequence(state) {
            return state.nextTestBlindSequence;
        },
        getTestBlindMarkups(state, sequence) {
            return state.testBlindMarkups;
        },
        GET_SELECTED_COMMENT(state) {
            return state.selectedComment;
        },
        GET_IS_COMMENTS_PANEL_ACTIVE(state) {
            return state.isCommentsPanelActive;
        },
        getTagIdToHighlight(state) {
            return state.tagIdToHighlight;
        },
        getStampsUploadFolder(state) {
            return state.stampsUploadFolder;
        },
        getStampsUploadActive(state) {
            return state.stampsUploadActive;
        },
    },
}